import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Card, Heading, Text } from '../design-system';

export const Wrapper = styled(motion.div)`
  display: flex;
  padding: 0 40px;
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  margin: 0 auto;
  margin-bottom: 100px;
  flex-direction: column;
`;

export const GridItemWrapper = styled(Card)`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StyledH1 = styled(Heading).attrs({ renderAs: 'h1' })`
  margin-bottom: 16px;
`;

export const Left = styled.div`
  width: 20%;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    width: 100%;
  }
`;

export const Right = styled.div`
  width: 80%;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  width: 80%;
  margin-bottom: 40px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    width: 100%;
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    grid-template-columns: 1fr;
    margin-top: 20px;
  }
`;

export const Title = styled(Heading).attrs({ renderAs: 'h4' })`
  margin-bottom: 6px;
`;

export const Info = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  flex-direction: column;
`;

export const StyledInfo = styled(Info)`
  padding: 15px 5px 5px;
`;

export const PreviewImage = styled.div`
  margin-bottom: 0;
  border: none;
  position: relative;
  flex: none;
  overflow: hidden;
`;

export const StyledPreviewImage = styled(PreviewImage)`
  width: 100%;
  height: 220px;
`;

export const SubHeading = styled.div`
  ${({ theme }) => theme.banner};
`;

export const Author = styled(Text)`
  opacity: 0.8;
  margin: 0px 0px 6px;
`;
